import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/cw/reimburses/list", params, successCallback, failCallback, exceptionCallback);
	},listCount: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/cw/reimburses/listCount", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/cw/reimburses/save", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/cw/reimburses/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},

	listMthOneYear: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/cw/reimburses/listMthOneYear", params, successCallback, failCallback, exceptionCallback);
	},
	listUsrHasReimAtMth: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/cw/reimburses/listUsrHasReimAtMth", params, successCallback, failCallback, exceptionCallback);
	},

	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/cw/reimburses/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/cw/reimburses/remove", params, successCallback, failCallback, exceptionCallback);
	},payAll: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/cw/reimburses/payAll", params, successCallback, failCallback, exceptionCallback);
	},
	//审批
	approve: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/cw/reimburses/approve", params, successCallback, failCallback, exceptionCallback);
	},
	//发放
	pay: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/cw/reimburses/pay", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
